export const PREVIEW_BLOCKED_EVENT = 'certslate:preview-blocked'

/** True while an admin is viewing a client's portal via "View client portal" (a read-only session). */
export const isPreviewSession = () => !!sessionStorage.getItem('previewClientName')

/**
 * Call at the top of any portal action that changes data. In a preview session it opens the
 * "read-only" dialog and returns true (the caller should stop); otherwise returns false.
 * The API rejects preview writes regardless - this only makes the refusal friendly and immediate.
 */
export function guardPreview(): boolean {
  if (!isPreviewSession()) return false
  window.dispatchEvent(new Event(PREVIEW_BLOCKED_EVENT))
  return true
}
